import { atom } from 'recoil';

export const PlaceTypeState = atom({
    key: 'PlaceTypeState',
    default: {}
});